export default "__VITE_ASSET__C_nw_dfy__"